import { getBillingPlans } from "@/lib/billing-api"

function isValidTrialPayload(trial) {
  return Boolean(
    trial
    && typeof trial.eligible === "boolean"
    && Number.isInteger(trial.days)
    && trial.days >= 1
  )
}

export async function billingPlansLoader() {
  try {
    const { plans, trial } = await getBillingPlans()
    if (!Array.isArray(plans)) throw new Error("Invalid billing plans response")
    if (!isValidTrialPayload(trial)) throw new Error("Invalid billing trial response")

    return { plans, trial, plansLoadFailed: false }
  } catch {
    return { plans: [], trial: null, plansLoadFailed: true }
  }
}
